
  import { Vue, Component, Prop } from "vue-property-decorator";

  import Visa from "@/components/icons/paymentCards/Visa.vue";
  import AmericanExpress from "@/components/icons/paymentCards/AmericanExpress.vue";
  import Discover from "@/components/icons/paymentCards/Discover.vue";
  import MasterCard from "@/components/icons/paymentCards/MasterCard.vue";
  import DinersClub from "@/components/icons/paymentCards/DinersClub.vue";
  import JCB from "@/components/icons/paymentCards/JCB.vue";
  import UnionPay from "@/components/icons/paymentCards/UnionPay.vue";

  import isPaymentCardExpired from "@/helpers/payment/isPaymentCardExpired";

  @Component({
    components: {
      Visa,
      AmericanExpress,
      Discover,
      MasterCard,
      DinersClub,
      JCB,
      UnionPay,
    },
  })
  export default class PaymentCard extends Vue {
    @Prop({ type: String, required: true }) readonly expMonth!: string;
    @Prop({ type: String, required: true }) readonly expYear!: string;
    @Prop({ type: String, required: true }) readonly last4!: string;
    @Prop({ type: String, required: true }) readonly updatedAt!: string;
    @Prop({ type: String, required: true }) readonly brand!: string;

    processing: boolean = false;

    get cardName(): string {
      return this.brand
        .split(" ")
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join("");
    }

    get formattedUpdatedAt(): string {
      return this.$moment(this.updatedAt).format("DD MMM YYYY");
    }

    get isExpired(): boolean {
      return isPaymentCardExpired({
        expMonth: this.expMonth,
        expYear: this.expYear,
      });
    }

    get expiresDate(): string {
      return `${this.expMonth}/${this.expYear}`;
    }
  }
